import { render, staticRenderFns } from "./RosterIndex.vue?vue&type=template&id=c36adeb6"
import script from "./RosterIndex.vue?vue&type=script&lang=js"
export * from "./RosterIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports